import Collapse from "./collapse";
import Icon from "@Shared/components/general/fa-icon.vue";
import InlineLoader from "@Shared/components/general/inline-loader.vue";
import NoResults from "@Shared/components/general/no-results.vue";
import ButtonLoader from "@Shared/components/general/button-loader.vue";
import InputRequiredIndicator from "@Shared/components/general/input-required-indicator.vue";
export default Vue => {
  //eslint-disable-next-line vue/component-definition-name-casing
  Vue.component("collapse", Collapse);
  Vue.component("Icon", Icon);
  Vue.component("InlineLoader", InlineLoader);
  Vue.component("NoResults", NoResults);
  Vue.component("ButtonLoader", ButtonLoader);
  Vue.component("InputRequiredIndicator", InputRequiredIndicator);
};